import { render } from "./NewsMaster.vue?vue&type=template&id=c4b7cad6&scoped=true"
import script from "./NewsMaster.vue?vue&type=script&lang=js"
export * from "./NewsMaster.vue?vue&type=script&lang=js"

import "./NewsMaster.vue?vue&type=style&index=0&id=c4b7cad6&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b7cad6"]])

export default __exports__